//import { CustomRequestOptions } from './shared/shared-service/restAPI.service';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DataTablesModule } from 'angular-datatables';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BlockUIModule } from 'ng-block-ui';
import { AppComponent } from './app.component';


import { RestAPIService } from '../app/shared/shared-service/restAPI.service';
import { SharedDataService } from '../app/shared/shared-data/shared-data.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RegisterApplicationComponent } from './register-application/register-application.component';
import { HeaderComponent } from './shared/header/header.component';
import { DetailsComponent } from './details/details.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { LayoutComponent } from './layout/layout.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { ErrorComponent } from './error/error.component';
import { AuditComponent } from './audit/audit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ApplicationLoginLogComponent } from './application-login-log/application-login-log.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ApplicationsComponent } from './applications/applications.component';
import { CommonModule, DatePipe } from '@angular/common';
import { StatComponent } from './shared/stat/stat.component';
import { MultiEmailValidationDirectiveDirective } from './multi-email-validation-directive.directive';
import { IpaddressValidationDirective } from './ipaddress-validation.directive';
import { CustomTableComponent } from './shared/custom-table/custom-table.component';


@NgModule({
  declarations: [
    AppComponent,
    RegisterApplicationComponent,
    HeaderComponent,
    DetailsComponent,
    LayoutComponent,
    SidebarComponent,
    DashboardComponent,
    ErrorComponent,
    AuditComponent,
    ApplicationLoginLogComponent,
    ApplicationsComponent,
    StatComponent,
    MultiEmailValidationDirectiveDirective,
    IpaddressValidationDirective,
    CustomTableComponent
    ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    DataTablesModule.forRoot(),
    FormsModule,
    NgbModule,
    ModalModule.forRoot(),
    BlockUIModule.forRoot(),
    AngularMultiSelectModule,
    CommonModule
  ],
  providers: [
    RestAPIService, 
    SharedDataService, 
    DatePipe,
    DeviceDetectorService
   // { provide: RequestOptions, useClass: CustomRequestOptions }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
